import * as statements from '../../statements';
import { FactName } from '../../../../../api-types';
const { isFactType, isTeamMilestone, isPlayerMilestone, isTeamComparisonMilestone } = statements;
export const GOAL = (args) => isFactType(FactName.GOAL)(args.fact);
export const RED_CARD = (args) => isFactType(FactName.RED_CARD)(args.fact);
export const YELLOW_CARD = (args) => isFactType(FactName.YELLOW_CARD)(args.fact);
export const PLAYER_MILESTONE = (args) => isPlayerMilestone(args);
export const TEAM_MILESTONE = (args) => isTeamMilestone(args);
export const TEAM_COMPARISON_MILESTONE = (args) => isTeamComparisonMilestone(args);
//# sourceMappingURL=live.js.map